import Schema, { required, optional, array, obj } from "AppReact/schema";


export const videoCardDefaultValue = {
  id: "",
  title: "",
  status: "",
  url: "",
  thumbnail: "",
};

export const videoCard = {
  id: required("string"),
  title: required("string"),
  url: required("string"),
  thumbnail: required("string"),
  status: required("string"),
};

export default {
  categoryId: Schema('integer', 'primitive', { defaultValue: 0 }),
  videoCard: Schema(videoCard, 'object', { defaultValue: videoCardDefaultValue }),
}
